import { defaultBrowseSortFilterValue, SortFilterValue } from '@/lib/filters/filters'
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import React, { useEffect, useState } from 'react'
import { cn } from '@/lib/utils'
import { ArrowDownUp } from 'lucide-react'
const options: Array<{ label: string; value: SortFilterValue }> = [
  { label: 'Relevance', value: 'relevance' },
  { label: 'New', value: 'new' },
  { label: 'Popular', value: 'popular' },
  { label: 'Trending', value: 'trending' },
]

export type SortFilterProps = {
  triggerClassName?: string
  contentClassName?: string
  value?: SortFilterValue
  enabled?: boolean
  onChange?: (value?: SortFilterValue) => void
  iconOnly?: boolean
}

export default function SortFilter({
  triggerClassName,
  contentClassName,
  value: initialValue,
  enabled = true,
  onChange = () => {},
  iconOnly = false,
}: SortFilterProps) {
  const [value, setValue] = useState<SortFilterValue>(initialValue ?? defaultBrowseSortFilterValue)
  useEffect(() => {
    setValue(initialValue ?? defaultBrowseSortFilterValue)
  }, [initialValue])

  return (
    <Select
      value={value}
      disabled={!enabled}
      onValueChange={(value: SortFilterValue) => {
        onChange(value)
      }}
    >
      <SelectTrigger
        className={cn(
          '!tw-bg-[var(--Primary-400)]',
          iconOnly && '!tw-bg-transparent [&>svg]:tw-hidden',
          triggerClassName
        )}
        disabled={!enabled}
        data-active={iconOnly && initialValue !== undefined ? true : undefined}
        aria-label={iconOnly ? `Sort assets: ${options.find((option) => option.value === value)?.label}` : undefined}
        title={iconOnly ? `Sort assets: ${options.find((option) => option.value === value)?.label}` : undefined}
      >
        {iconOnly ? (
          <span>
            <ArrowDownUp size={16} aria-hidden="true" />
          </span>
        ) : (
          <SelectValue placeholder="Select an option..." />
        )}
      </SelectTrigger>
      <SelectContent className={cn('!tw-border-0 !tw-bg-[var(--Primary)]', contentClassName)}>
        <SelectGroup>
          {options.map((option) => (
            <SelectItem
              key={`${option.value ?? defaultBrowseSortFilterValue}-option`}
              className="tw-cursor-pointer"
              value={option.value ?? defaultBrowseSortFilterValue}
            >
              {option.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}
